import { Dropdown, DropdownItemProps, DropdownProps } from 'semantic-ui-react';
import React, { useState } from 'react';
import './DropdownSelectRowsPerPage.less';

export interface Props extends DropdownProps {
  handleOnChange?: (pageSize: number) => void;
  totalRows: number;
  pageIndex: number;
  dropDownOptions?: DropdownItemProps[];
}

const options = [
  { text: 10, value: 10 },
  { text: 25, value: 25 },
  { text: 50, value: 50 },
  { text: 'All', value: 10000 },
];

const getRangeSelection = (range: number, pageIndex: number): string => {
  if (pageIndex === 0) {
    return '1-' + range;
  }
  const startValue = pageIndex * range + 1;
  const endValue = (pageIndex + 1) * range;
  return startValue + '-' + endValue;
};

export const DropdownSelectRowsPerPage = (props: Props) => {
  const [_value, setValue] = useState(10);
  return (
    <div className="pos-dropdown-rows-per-page">
      <span className="title">Rows per page: </span>
      <Dropdown
        className="dropdown"
        defaultValue={_value}
        options={props.dropDownOptions ?? options}
        onChange={(_event, { value }) => {
          setValue(value as number);
          props.handleOnChange && props.handleOnChange(value as number);
        }}
      />
      <span className="range-info">
        {getRangeSelection(_value, props.pageIndex)} of {props.totalRows}
      </span>
    </div>
  );
};
